import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const Content = styled.div.withConfig({
    displayName: "styled__Content",
    componentId: "sc-3bb0e91b-0"
})`
	padding: ${({ $fullWidth  })=>$fullWidth ? '0' : '0px 16px 8px'};
	border-bottom: 2px solid ${({ theme  })=>theme.colors.primary.light};

	&:first-child {
		margin-top: 12px;
	}

	&:not(:last-child) {
		margin-bottom: 12px;
	}
`;
export const ExtraInfo = styled.div.withConfig({
    displayName: "styled__ExtraInfo",
    componentId: "sc-3bb0e91b-1"
})`
	${FontMixin({
    size: 'medium',
    weight: 'regular'
})}
	line-height: 18px;
	color: ${({ theme  })=>theme.colors.text};
	background-color: ${({ theme  })=>theme.colors.primary.lightestL};
	padding: 13px 50px 11px 12px;
	border-bottom: 1px solid ${({ theme  })=>theme.border.color.light};
	border-top: 1px solid ${({ theme  })=>theme.border.color.light};
`;
export const ContentHeader = styled.div.withConfig({
    displayName: "styled__ContentHeader",
    componentId: "sc-3bb0e91b-2"
})`
	${FlexMixin({
    align: 'flex-end',
    justify: 'space-between'
})}
	gap: 8px;
	margin-bottom: 8px;
`;
export const ContentHeaderTitle = styled.p.withConfig({
    displayName: "styled__ContentHeaderTitle",
    componentId: "sc-3bb0e91b-3"
})`
	${FontMixin({
    size: 'large',
    height: 'large',
    weight: 'medium'
})}
	color: ${({ theme  })=>theme.colors.grays.darker};
`;
export const ContentHeaderDescription = styled.p.withConfig({
    displayName: "styled__ContentHeaderDescription",
    componentId: "sc-3bb0e91b-4"
})`
	${FontMixin({
    size: 'small',
    height: 'small',
    weight: 'light'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
`;

//# sourceMappingURL=styled.js.map